import {mutations} from './mutations';
import {getters} from './getters';
import {actions} from './actions';
import {MainState} from './state';
import {IUserProfile, IUserStats} from "@/interfaces/user";
import {IFormValues} from "@/interfaces/form";

const defaultState: MainState = {
  isLoggedIn: null,
  token: '',
  logInError: false,
  noServerConnection: false,
  userProfile: {} as unknown as IUserProfile,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  form: null,
  forms: [],
  menu_form: null,
  menu_forms: [],
  form_values: {} as unknown as IFormValues,
  forms_values: [],
  external_data: null,
  search_engine: null,
  forms_files: [],
  form_batches: null,
  query_builder: null,
  printer_log: null,
  printer_logs: [],
  access_log: null,
  access_logs: [],
  visited_pages: [],
  permissions: [],
  userStats: {} as unknown as IUserStats,
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
